import styled from "styled-components";

export const SidebarOptionContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  padding: 5px 2px 5px 0px;
  cursor: pointer;
  font-weight: 400;

  :hover {
    background-color: #340e36;
    font-size: 14px;
  }

  > h3 {
    font-weight: 400;
  }

  > h3 > a > span {
    padding: 15px;
  }

  > h3 > a {
    text-decoration: none;
    color: white;
  }
`;

export const SidebarOptionChannel = styled.h3``;
